import { Component, Inject, OnDestroy } from '@angular/core';
import { FormControl, Validators } from "@angular/forms";
import { BehaviorSubject, of, Subject } from "rxjs";
import { catchError, takeUntil, filter } from "rxjs/operators";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { HttpClient } from "@angular/common/http";

export interface IDialogData {
  name: string,
  configuration: {
    key: string
    parameters: { [key: string]: number | string };
    resources: { [key: string]: number };
  };
  previewUrl: string;
  exportUrl: string;
}

@Component({
  selector: 'app-order-dialog',
  templateUrl: './order-dialog.component.html',
  styleUrls: ['./order-dialog.component.scss']
})
export class OrderDialogComponent implements OnDestroy {
  private configurationId: string;
  public busy$ = new BehaviorSubject<boolean>(false);
  public completed$ = new Subject<boolean>();
  public error$ = new Subject<any>();
  public unsubscribe$ = new Subject<void>();

  public email = new FormControl('', [
    Validators.required,
    Validators.email
  ]);

  constructor(public dialogRef: MatDialogRef<OrderDialogComponent>, public httpClient: HttpClient,
    @Inject(MAT_DIALOG_DATA) public dialogData: IDialogData) {
  }

  public order() {
    console.log('this.configurationId = ', this.configurationId);
    this.error$.next(null);
    this.completed$.next(false);
    this.busy$.next(true);

    const addressData = {
      name: this.email.value,
      email: this.email.value,
      address1: 'uitbreidingstraat 60',
      town: 'Berchem',
      isoCountry: 'BE',
      postcode: '2850'
    };

    const order = {
      order: {
        flowKey: this.dialogData.name,
        spaceKey: 'assist3d',
        thirdPartyOrderId: 'Order ' + this.dialogData.name + ' ' + Date.now(),
        updateUrl: 'https://dev-hp.twikit.com/order',
        addresses: [
          {
            purpose: 'instruction',
            addressType: 'e-mail',
            data: addressData
          }
        ],
        data: {},
        orderLines: [
          {
            data: {
              sku: '3dTestFile',
              parameters: this.dialogData.configuration.parameters,
              resources: this.dialogData.configuration.resources,
              productUrl: this.dialogData.exportUrl,
              twikbotVersion: (window as any).twikit.twikbotVersion
            },
            title: this.dialogData.name,
            amountOfUnits: 1,
            valuePerUnit: 100,
            deadline: '2020-03-23',
            items: [
              {
                data: {},
                items: [],
                assets: [
                  {
                    url: this.dialogData.previewUrl
                  }
                ]
              }
            ]
          }
        ]
      }
    };                // this data should probably be stored somewhere in your database for later use
    console.log('order = ', order);

    this.httpClient.post('https://orders.twikit.com/api/order/create', order)
      .pipe(
        catchError(err => {
          this.error$.next(err);
          this.busy$.next(false);
          return of(null);
        }),
        takeUntil(this.unsubscribe$),
        filter(f => f != null),
      )
      .subscribe((orderData) => {
        this.dialogRef.close(orderData);
      });
  }

  onNoClick() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
